import ImageScrollbar from './ImageScrollbar';
export default ImageScrollbar;
